import { gql } from '@apollo/client';

export const DELETE_ANIMAL_IMAGE = gql`
  mutation deleteAnimalImage($fileName: String!) {
    deleteAnimalImage(fileName: $fileName)
  }
`;
